
import { useEffect } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import useQueryString from 'utils/hooks/useQueryString';
import { scrollToElement } from 'lib/userFunctions';
import { Loading } from 'app/components/Loading';
import queryString from 'query-string';
import { StoryViewItem } from './StoryViewItem';
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { LikeButton } from "app/components/LikeButton";
import { ErrorMessageBox } from 'bf-library';
import { toast } from 'react-toastify';

export const StoryView = () => {
    const navigate = useNavigate();
    const { school, storyId } = useParams();
    const queryParams = useQueryString();
    const queryClient = useQueryClient();
    const auth = useSelector(state => state.auth);

    useEffect(() => scrollToElement(), []);

    const { data: story, isLoading, isError, error } = useQuery({
        queryKey: ['donghwa/story', storyId],
        queryFn: () => Api.get(`/api/dongwha/story/${storyId}`)
    });

    const deleteMutate = useMutation({
        mutationFn: () => Api.get(`/api/dongwha/story/${storyId}/delete`),
        onSuccess: (res) => {
            const topicId = story?.data?.topicId;
            queryClient.invalidateQueries({ queryKey: ['donghwa/topic/stories', { page: 0, sort: 'id,desc', bestYn: 'N', user: 'N', topicId }] });
            queryClient.invalidateQueries({ queryKey: ['donghwa/topic', topicId] });
            navigate(`/${school}/donghwa/${topicId}`);
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err);
            toast.error(errorData.message);
        }
    });

    const onDeleteStory = () => {
        if (deleteMutate.isPending) return;
        if (window.confirm("작품을 정말 삭제하시겠습니까?")) deleteMutate.mutate();
    };


    if (isLoading) return <Loading />;
    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;

    return (
        <div className={`topicPage ${story?.data?.bestYn === 'Y' ? 'bestStoryPage' : ''} ${story?.data?.deleteYn === "Y" ? "delete" : ""}`}>
            <div className="inner">
                {story?.data?.bestYn === 'Y' && <h2 className="bestStoryTitle">훈장님이 뽑은 장원급제 작품</h2>}

                <StoryViewItem story={story?.data} useComment={true} showCommentCount={true}>
                    {/* 필요하면 컨트롤을 넣을 수 있다 */}
                    <div className="item_btn center">
                        <Link to={`/${window.schoolCode}/donghwa/${story?.data?.topicId}${queryParams.list === 'my' ? '/my' : ''}?${queryString.stringify(queryParams)}`} className="btn _white">
                            <i className="fa-solid fa-list"></i> 목록으로
                        </Link>
                        {story?.data?.user?.userid === auth.userid && story?.data?.deleteYn !== "Y" &&
                            <Link to={`/${window.schoolCode}/donghwa/${story?.data?.topicId}/edit/${storyId}`} className="btn _white">
                                <i className="fa-regular fa-pen-to-square"></i> 수정하기
                            </Link>
                        }
                        <LikeButton activity={story?.data} type="dongwhaStory" />
                        {story?.data?.user?.userid === auth.userid && story?.data?.deleteYn !== "Y" &&
                            <button className="btn _red" onClick={onDeleteStory}>
                                <i className="fa-regular fa-trash-can"></i>삭제하기
                            </button>
                        }
                    </div>
                </StoryViewItem>
            </div>
        </div>
    );
};